import React, {Component} from 'react';
import {Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row} from "reactstrap";
import axios from "axios";
import {serverPath} from "./common";


class LoginModal extends Component{
    constructor(props){
        super(props);

        this.state={
            isOpen: false,
            forgotPasswordModalOpen: false,
            forgotPasswordMessage: "",
        };
        this.toggleModal = this.toggleModal.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handleLoginClick = this.handleLoginClick.bind(this);
        this.forgotPassword = this.forgotPassword.bind(this);
        this.toggleForgotPasswordModal = this.toggleForgotPasswordModal.bind(this);
    }

    toggleModal(){
        let self = this;
        if(this.state.isOpen){
            self.props.handleClose();
        }
        this.setState({
            isOpen: !self.state.isOpen,
        })
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps.parentWantsModal){
            this.setState({isOpen: true});
        }
    }

    handleLogin(username, pass, toggleModal){
        const params = new URLSearchParams();
        params.append('username', username);
        params.append('password', pass);
        params.append('action', 'login');

        let self = this;
        axios.post(serverPath + "authService.php", params)
            .then(function (response) {
                if (response.data !== null) {
                    // self.setState({ user: response.data });
                    self.props.loginComplete(response.data);
                    if(toggleModal){
                        self.toggleModal();
                    }
                }
                else {
                    self.props.loginFailed();
                }
            });
    }
    handleLoginClick(_event) {
        this.handleLogin(this.username.value, this.password.value, true);
    }
    /*********************************************FORGOT PASSWORD OPTIONS*********************************************/

    forgotPassword(){
        const username = this.forgotPasswordUsername.value;
        var self = this;
        const params = new URLSearchParams();
        params.append('action', 'forgotPassword');
        params.append('username', username);
        axios.post(serverPath + "authService.php",params).then((resp)=>{
            if(resp.data.success === true){
                var emailSplited = resp.data.email.split("@");
                const usernameLength = emailSplited[0].length;
                var numOfChars = usernameLength > 3 ? 3 : 0;
                const stars = "*".repeat(usernameLength-3);
                const email = stars+emailSplited[0].slice(-numOfChars)+"@"+emailSplited[1];
                self.setState({
                    forgotPasswordMessage: "Link za obnovu šifre je poslat na: " + email+"\nLink važi 8 sati.",
                });
            }
            else{
                if(resp.data.reason === "username"){
                    self.setState({
                        forgotPasswordMessage: "Nepostojeće korisničko ime!",
                    });
                }
            }
        });
    }
    toggleForgotPasswordModal(){
        const currState = this.state.forgotPasswordModalOpen;
        this.setState({
            forgotPasswordModalOpen: !currState,
            forgotPasswordMessage:"",
        })
    }
    render(){
        return(
            <React.Fragment>

                <Button color="warning" outline onClick={this.toggleModal}>
                    <span className="fa fa-sign-in fa-lg"> </span> Prijavi se
                </Button>
                <Modal isOpen={this.state.forgotPasswordModalOpen}
                       toggle={this.toggleForgotPasswordModal}>
                    <ModalHeader toggle={this.toggleForgotPasswordModal}>
                        Zaboravili ste šifru?
                    </ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label htmlFor={'username'}> Korisničko ime</Label>
                            <Input name={'username'} id={'username'}
                                   innerRef={(ref)=>{this.forgotPasswordUsername=ref}}/>
                        </FormGroup>
                        <Button color={'primary'} onClick={this.forgotPassword}>
                            Pošalji kod za resetovanje
                        </Button>
                        <h4>{this.state.forgotPasswordMessage}</h4>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.isOpen} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        Prijava na sistem
                    </ModalHeader>
                    <ModalBody>
                        <Form>
                            <FormGroup>
                                <Label htmlFor="username">
                                    Korisničko ime (studenti MATF-a se loguju alas nalogom)
                                </Label>
                                <Input type="text" id="username" name="username"
                                       innerRef={(input) => this.username = input} />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="password"> Šifra </Label>
                                <Input type="password" id="password" name="password"
                                       innerRef={(input) => this.password = input} />
                            </FormGroup>
                            <Row>
                                <Col>
                                    <Button type="submit" color="primary"
                                            onClick={(event) => {
                                                this.handleLoginClick(event);
                                                event.preventDefault();
                                            }
                                            }>
                                        Prijavi se
                                    </Button>
                                </Col>
                                <Col>
                                    <Button color={'danger'}
                                            onClick={this.toggleForgotPasswordModal}>Zaboravili ste šifru?</Button>
                                </Col>

                            </Row>
                        </Form>
                    </ModalBody>
                </Modal>
            </React.Fragment>

        );
    }
}
 export {LoginModal}